export default __webpack_public_path__ + "static/media/freight-receipt-dark.c719b1ed.svg";